module.exports = __webpack_public_path__ + "static/media/heycar_1.f0a66bff.png";